import { render } from "./dark_mode.vue?vue&type=template&id=05c6208a&scoped=true"
import script from "./dark_mode.vue?vue&type=script&lang=js"
export * from "./dark_mode.vue?vue&type=script&lang=js"

import "./dark_mode.vue?vue&type=style&index=0&id=05c6208a&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c6208a"]])

export default __exports__